<div class="chart-card">
  <div class="chart-header">
    <div class="header-left">
      <h3 class="chart-title">{{ title }}</h3>
      @if (!isLoading && hasData()) {
        <app-graph-trend-icon
          [percentageChange]="totalPercentageChange"
          [formattedChange]="formatPercentChange()"
          [formatValue]="formatBudget(totalValue)"
          [isUptrendPositive]="isUptrendPositive()">
        </app-graph-trend-icon>
      }
    </div>

    <div class="header-right date-height" ngbDropdown>
      <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
        [disabledIntervals]="disabledIntervals" [defaultInterval]="defaultInterval"
        (filterChanged)="onDateFilterChange($event)">
      </app-date-filter>
    </div>
  </div>

  <div class="chart-body">
    @if (isLoading) {
      <div class="card-loader">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    } @else if (!hasData()) {
      <div class="d-flex align-items-center justify-content-center no-data">
        <app-empty-state></app-empty-state>
      </div>
    } @else {
      <div class="categories-list">
        @for (category of categories; track category.budgetCategoryId) {
          <div class="category-item">
            <div class="category-header">
              <span class="category-name">{{ category.name | lookupLabel:budgetCategoryLabels }}</span>
              <span class="category-change" [class.positive]="category.percentageChange > 0" [class.negative]="category.percentageChange < 0">
                {{ formatSignedPercentage(category.percentageChange) }}
              </span>
            </div>
            <div class="category-details">
              <span class="category-current">{{ 'costTracking.distribution.currentBudget' | transloco: { current: formatBudget(category.currentCost), budget: formatBudget(category.budgetCost) } }}</span>
            </div>
            <div class="category-value">{{ formatBudget(category.currentCost) }}</div>
          </div>
        }
      </div>
    }
  </div>
</div>